import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./stepSection.html";
import { i18nStore } from '~/modules/stores/i18nStore';
class StepSection extends LightningElement {
  constructor(...args) {
    super(...args);
    this.stepTitle = void 0;
    this.stepNumber = void 0;
  }
  get stepNumberLabel() {
    return i18nStore.getState().i18n.shared.stepNumber({
      NUMBER: this.stepNumber
    });
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(StepSection, {
  publicProps: {
    stepTitle: {
      config: 0
    },
    stepNumber: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(StepSection, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;